import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SaveBtn from "../../../component/atoms/button/saveBtn";
import MainInput from "../../../component/atoms/input/mainInput";
import Radio from "../../../component/atoms/input/radio";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import GoBack from "../../../component/molecules/goBack";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import Modal from "../../../component/templates/Modal";
import { errorHandler } from "../../../util/errorHandler";
import { modalMsg } from "../../../util/modalMsg";
import { toastMsg } from "../../../util/toastMsg";
import ColumnApi from "../../../api/column.api";

function ColumnCategoryAdd() {
  // import
  const navigate = useNavigate();

  const [categoryData, setCategoryData] = useState({
    title: "",
    activation: true,
  });

  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const saveFunc = async () => {
    try {
      await ColumnApi.addCategory({
        ...categoryData,
        title: categoryData.title.trim(),
      });
      setSaveModalOpen(false);
      navigate(-1);
      toast(toastMsg.create);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
          </DetailTop>
          <DetailPage>
            <DetailPageTitle>추가하기</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm>
                <DetailFormTitle>활성 상태*</DetailFormTitle>
                <div style={{ display: "flex", gap: "20px" }}>
                  <Radio
                    id={"true"}
                    name={"activation"}
                    valueText={"활성"}
                    checked={categoryData.activation}
                    onChange={() => {
                      setCategoryData({
                        ...categoryData,
                        activation: true,
                      });
                    }}
                  />
                  <Radio
                    id={"false"}
                    name={"activation"}
                    valueText={"비활성"}
                    checked={!categoryData.activation}
                    onChange={() => {
                      setCategoryData({
                        ...categoryData,
                        activation: false,
                      });
                    }}
                  />
                </div>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>카테고리명*</DetailFormTitle>
                <MainInput
                  style={{
                    width: "338px",
                  }}
                  type={"text"}
                  placeholder={"카테고리명을 입력해주세요"}
                  value={categoryData.title}
                  onChange={(e) =>
                    setCategoryData({ ...categoryData, title: e.target.value })
                  }
                />
              </DetailPageForm>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "30px",
              }}
            >
              <SaveBtn
                onClick={() => {
                  if (!categoryData.title.trim()) {
                    return toast("카테고리명을 입력해주세요.");
                  }

                  setSaveModalOpen(true);
                }}
              />
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={modalMsg.update?.title}
          text={modalMsg.update?.content}
          setModalOpen={setSaveModalOpen}
          onClick={saveFunc}
        />
      ) : null}
    </>
  );
}

export default ColumnCategoryAdd;
